// src/utils/ascendant.js
// Cálculo astronómico real del Ascendente (signo ascendente) a partir de fecha, hora local,
// offset UTC y coordenadas geográficas. Fórmulas de Jean Meeus (Astronomical Algorithms):
// Día Juliano (cap. 7), GMST (cap. 12, IAU 1982) y Oblicuidad de la eclíptica (cap. 22).
// Sin dependencias externas — solo Math nativo.

const SIGNOS = [
  'Aries', 'Tauro', 'Géminis', 'Cáncer', 'Leo', 'Virgo',
  'Libra', 'Escorpio', 'Sagitario', 'Capricornio', 'Acuario', 'Piscis',
];

const toRad = (d) => (d * Math.PI) / 180;
const toDeg = (r) => (r * 180) / Math.PI;
const norm360 = (d) => {
  let x = d % 360;
  if (x < 0) x += 360;
  return x;
};

export function calcularAscendente({ year, month, day, hourLocal, minuteLocal, utcOffset, lat, lon }) {
  const ut = hourLocal + minuteLocal / 60 - utcOffset;

  // 1. Día Juliano (calendario gregoriano)
  let Y = year;
  let M = month;
  if (M <= 2) { Y -= 1; M += 12; }
  const A = Math.floor(Y / 100);
  const B = 2 - A + Math.floor(A / 4);
  const jd = Math.floor(365.25 * (Y + 4716)) + Math.floor(30.6001 * (M + 1)) + (day + ut / 24) + B - 1524.5;

  // 2. Tiempo Sidéreo Medio de Greenwich (GMST), en grados
  const T = (jd - 2451545.0) / 36525;
  const gmst = norm360(
    280.46061837 + 360.98564736629 * (jd - 2451545.0) + 0.000387933 * T * T - (T * T * T) / 38710000
  );

  // 3. Tiempo Sidéreo Local (longitud Este positiva, Oeste negativa)
  const lst = norm360(gmst + lon);

  // 4. Oblicuidad de la eclíptica
  const eps = 23.439291111 - 0.0130041667 * T - 0.00000016389 * T * T + 0.00000050361 * T * T * T;

  // 5. Ascendente (grados eclípticos 0-360)
  const R = toRad(lst);
  const E = toRad(eps);
  const L = toRad(Math.max(-89.9, Math.min(89.9, lat))); // evita indeterminación en latitudes polares
  const y = Math.cos(R);
  const x = -(Math.sin(R) * Math.cos(E) + Math.tan(L) * Math.sin(E));
  const ascGrados = norm360(toDeg(Math.atan2(y, x)));

  // 6. Signo zodiacal correspondiente
  const signo = SIGNOS[Math.floor(ascGrados / 30)];
  const gradoEnSigno = ascGrados % 30;

  return { ascGrados, signo, gradoEnSigno };
}
